<template>
		<div class="study">
			<van-nav-bar fixed left-arrow @click-left="clickNavBack" :border="false" z-index="11"/>
			<div class="player"/>
			<div class="main" style="position:relative;">
				<studyTitle
				:info="playVideo"
				:loadingFace="loadingFace"
				@handleFace="handleFace"
				@imgChange="imgChange"
				/>
				<div class="content">
				<studySidebar
					:list="videoTree"
					:cur="playVideoChapter"
					:act="orderChapterLocal"
					:actVideo="playVideo"
					@clickToggleChapter="clickToggleChapter"
				/>
				<studyList
					:chapter="playVideoChapter"
					:current="playVideo"
					:mustVideo="orderVideoLocal"
					:isPlayState="isPlayState"
					:videoList="videoList"
					@clickVideo="clickVideo"
				/>
			</div>
			</div>
			<!-- <div class="sign-wrap" v-if="showPopover">
				<div>
					<img src="../../assets/v-tips.png" alt="">
				</div>
				<div class="sign-text">
					<div v-for="(item,index) in issign" :key="index" class="text-box" @click="signtip(index)">
						<div class="text-btns" :class="iscolor==index?'btn-color':''"></div>
						<span class="text-text">{{ item.text }}</span>
					</div>
				</div>
			</div> -->
			<input v-show="false" ref="imgChange" @change="imgChange($event)" type="file" accept="image/*" capture="user">
		</div>
</template>

<script>
import 'xgplayer/dist/index.min.css'
import HlsJsPlugin from 'xgplayer-hls.js'
import Player,{ Events } from 'xgplayer'
import studyTitle from './components/title'
import studySidebar from './components/sidebar'
import {viewLogPush,lastWatchLength,getPlanInfo,getVideoUrl} from "../../api/user"
import {Dialog} from "vant";
import studyList from './components/list'
import store from "../../store";
import Compressor from 'compressorjs';
import {getUserId} from "@/utils/cookie";
// 需要独立引用是css文件

export default {
	name: 'study1',
	data: () => ({
		loadingFace:false,
		videoTree: [], // 视频数据结构树
		videoList: [], // 所有可播放视频节点的数组集合
		orderChapterLocal: {}, 	// 顺序播放视频的章节实际位置
		orderVideoLocal: {}, 	// 顺序播放视频实际位置
		playVideo: {}, // 正在播放的视频
		playVideoChapter: [], // 当前播放视频所属的章节
		isPlayState: false, // 当前是否正在播放
		showPopover: true,
		middleFace: false,
		faceRecognitionType: null,
		player: null,
		submitStudyTimer: null, 	// 定时器
		playModeType: '0', 			// 学习计划-连续播放状态
		provinceCode: null,			// 学习计划-省份代码
		categoryId: null,			// 学习计划-类别体系id
		pendingSeekTime: 0,			// 待恢复时间点（自动播放失败时用）
		needSeekToLast: true,		// 是否需要跳转到上次记录（true=首次进入/签到，false=切下一集）
		isNextVideoSwitch: false,	// 标记"切下一集"流程，跟 needSeekToLast 互不干扰（解决同步/异步混用导致 LOADED_METADATA 误判的问题）
		_gestureBound: false,		// 防止重复绑定用户手势监听
		_lastEndedBasePkId: null,	// 关键修复：上次 ENDED 处理的视频 basePkId，防止 xgplayer 在视频源切换后残留 ended 事件触发多次 loadNextVideo（导致跳过中间视频）
	}),
	issign: [{
				text: '我已知晓'
			}, {
				text: '别再提示'
			}
		],
	components: {studySidebar,studyList,studyTitle},
	computed: {
		userid() {
			return typeof (this.$store.state.user.userid) === 'undefined' ? getUserId() : this.$store.state.user.userid
		},
		isUseJSPlayPhoto() {
			if (this.$store.state.cache.screen.wx) return true
			if (this.$route.query.state === 'js') return false
			// if (sessionStorage.getItem('anhuihefei') === '1') {
			//	return false
			// }
			if (this.$store.state.cache.single && this.$store.state.cache.single.state === 'single') return true
			return true
		},
		appno() {
			return this.$store.state.app.appno
		}
	},
	created() {
		this.getPlanInfo()
		/** 清除签到人脸 **/
		this.$store.commit('cache/set_face', {key: 'signInPhoto', value: ''})
		/** 加载视频列表 **/
		this.loadVideoList()
		if (localStorage.getItem('showPopover')) {
			this.showPopover = JSON.parse(localStorage.getItem('showPopover'))
		} else {
			this.showPopover = true;
		}
	},
	mounted() {
		const _this = this
		/** 绑定拍照 JS 回调事件 **/
		window['receivePhotoResult'] = (base64) => {
			this.receivePhotoResult(base64);
		}
		window.getCameraData = (base64) => {
			console.log('uni-app.study 拍照回调', base64.substring(0, 10))
			this.receivePhotoResult(base64);
		}
		if (this.$store.state.cache.screen.wx) {
			this.uploading = true
			this.$api.wxConfig().then(res => {
				if (res.code === 0) {
					const data = res.data
					wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
						appId: data.appId, // 必填，公众号的唯一标识
						timestamp: data.timestamp, // 必填，生成签名的时间戳
						nonceStr: data.nonceStr, // 必填，生成签名的随机串
						signature: data.signature,// 必填，签名
						jsApiList: ['chooseImage', 'uploadImage'] // 必填，需要使用的JS接口列表
					})
				}
			})
			wx.ready(() => {
				_this.uploading = false
			})
			wx.error(err => {
				_this.uploading = false
				console.log('微信config出错 ===', err)
				this.$utils.dialog.alert(`微信config失败：${err.errMsg}`)
			})
		}
	},
	destroyed() {
		// 关键修复：离开页面停止所有定时器，防止 viewLogPush 持续调用
		this.timingSubmitStudyThrittle('clear')
		if (this.submitStudyTimer) {
			clearTimeout(this.submitStudyTimer)
			this.submitStudyTimer = null
		}
		if (this.timer) {
			clearTimeout(this.timer)
			this.timer = null
		}
		// 销毁播放器
		if (this.player && this.player.destroy) {
			this.player.destroy()
			this.player = null
		}
		console.log('[study1-index] destroyed 清理定时器')
	},
	methods:{
		// 获取学习计划
		getPlanInfo() {
			//const _this = this
			getPlanInfo(this.userid).then(res => {
				this.playModeType = res.playModeType;
				this.categoryId = res.categoryId;
				this.provinceCode = res.provinceCode;
				this.faceRecognitionType = res.faceRecognitionType;
				// 常州教练员允许倍速
				// if (',119,'.indexOf(',' + _this.categoryId + ',') !== -1 && _this.provinceCode === '320000') {
				// 	this.showRateBtn = 1;
				// }
			})
		},
		/** 点击切换播放的视频 **/
		clickVideo(video) {
			this.orderVideoLocal = this.videoList[this.orderVideoLocalIndex]
			if (video.watchedFlag === '0' && video.basePkId !== this.orderVideoLocal.basePkId) {
				this.$utils.dialog.alert('请按顺序进行学习')
			} else {
				this.playVideo = video
				// 关键修复：手动切视频时清掉 _lastEndedBasePkId，避免新视频 ENDED 被误判为重复
				this._lastEndedBasePkId = null
				if (this.playModeType === '1') {
					this.loadVideo(video)
				} else {
					this.loadVideo(video)
				}
			}
		},
		/** 加载下一个播放的视频节点
		 * @param {Object} [endedVideo] - 可选，ENDED 时实际播放的视频。如果不传则用 this.orderVideoLocal
		 *   关键修复：用 endedVideo（实际播放的视频）而非 orderVideoLocal（必学视频位置）作为 current
		 *   原因：用户手动点击已学视频复习时，orderVideoLocal 可能还是上一次的位置（如 video2），
		 *   但实际播放的是 video1。如果用 orderVideoLocal 作为 current 找下一个，
		 *   会跳过 video2（以为是 video2 ENDED 的下一个 = video3）。
		 */
		loadNextVideo(endedVideo) {
			// 关键修复：调用计数器，防止多次调用导致跳过
			this._loadNextVideoCallCount = (this._loadNextVideoCallCount || 0) + 1
			// 关键修复：幂等保护 - 同一 basePkId 不重复调 loadNextVideo
			//   原因：watchVideo API 异步返回 + 残留 ENDED 事件可能多次触发 loadNextVideo
			//   每次都会把 current.watchedFlag='1' 并切换下一集，多次调用导致跳过多集
			const current = endedVideo || this.orderVideoLocal
			console.log('[study1] loadNextVideo 入口 #' + this._loadNextVideoCallCount + ', current=', current && current.videoId, 'basePkId=', current && current.basePkId, 'chapterIndex=', current && current.chapterIndex, 'parentPkId=', current && current.parentPkId, '来源=', endedVideo ? 'endedVideo' : 'orderVideoLocal', 'isNextVideoSwitch=', this.isNextVideoSwitch)
			console.log('[study1] loadNextVideo 调用栈:', new Error().stack.split('\n').slice(1, 5).join(' | '))
			// 幂等：同一 basePkId 在切下一集流程中（isNextVideoSwitch=true）不重复处理
			if (this.isNextVideoSwitch && current && this._lastEndedBasePkId === current.basePkId) {
				console.log('[study1] loadNextVideo 已在切下一集，跳过 basePkId=', current.basePkId)
				return
			}
			this._lastEndedBasePkId = current ? current.basePkId : null
			console.log('[study1] loadNextVideo videoList=', JSON.stringify(this.videoList.map(v => ({
				idx: v.chapterIndex, id: v.videoId, basePkId: v.basePkId, parentPkId: v.parentPkId, watchedFlag: v.watchedFlag
			}))))
			if (current && current.watchedFlag !== '1') current.watchedFlag = '1'

			// 关键修复：不依赖 videoList[curIndex+1] 作为"下一个视频"
			//   原因：videoList 跨章节顺序不可靠（后端 getChapterList 无 ORDER BY），
			//   上一轮 chapterIndex 排序仅在同 parentPkId 内有效，跨章节无序
			//   → videoList[curIndex+1] 可能拿到错误视频，导致"跳过中间视频"
			//
			//   新逻辑：基于视频自身的 chapterIndex + parentPkId 找真正的下一个视频
			//   1) 优先找顺序上的下一个（不论是否已学），保证已学视频也能跳到下一集
			//   2) 找不到时兜底到 videoList 顺序上的下一个
			//
			// 关键修复：过滤排除当前视频自身（用 basePkId 判断），不再限制 watchedFlag='0'
			//   原因：用户播放已学视频（watchedFlag='1'）时，END 后需要能跳到下一个视频（无论是否已学）
			const nextCandidates = this.videoList.filter(v =>
				v.basePkId !== current.basePkId &&
				(
					(v.parentPkId === current.parentPkId && (v.chapterIndex || 0) > (current.chapterIndex || 0)) ||
					v.parentPkId !== current.parentPkId
				)
			)
			console.log('[study1] loadNextVideo nextCandidates=', JSON.stringify(nextCandidates.map(v => ({
				idx: v.chapterIndex, id: v.videoId, basePkId: v.basePkId, parentPkId: v.parentPkId, watchedFlag: v.watchedFlag
			}))))
			let next = null
			if (nextCandidates.length > 0) {
				// 1) 同章节内的下一个（按 chapterIndex 升序）
				const sameChapterNext = nextCandidates
					.filter(v => v.parentPkId === current.parentPkId && (v.chapterIndex || 0) > (current.chapterIndex || 0))
					.sort((a, b) => (a.chapterIndex || 0) - (b.chapterIndex || 0))[0]
				if (sameChapterNext) {
					next = sameChapterNext
					console.log('[study1] loadNextVideo 命中同章节下一集:', next.videoId)
				} else {
					// 2) 跨章节：按 parentPkId + chapterIndex 排序取第一个
					next = nextCandidates.slice().sort((a, b) => {
						if (a.parentPkId !== b.parentPkId) {
							return String(a.parentPkId).localeCompare(String(b.parentPkId))
						}
						return (a.chapterIndex || 0) - (b.chapterIndex || 0)
					})[0]
					console.log('[study1] loadNextVideo 命中跨章节下一集:', next.videoId)
				}
			} else {
				console.log('[study1] loadNextVideo 未找到下一集（已是最后一集或异常）')
			}

			if (next) {
				console.log('[study1] 切下一集:',
					'current=', current.videoId, 'chapterIndex=', current.chapterIndex, 'parentPkId=', current.parentPkId,
					'→ next=', next.videoId, 'chapterIndex=', next.chapterIndex, 'parentPkId=', next.parentPkId)
				this.orderVideoLocal = next
				// 关键修复：不在此处提前改 this.playVideo，
				//   让 switchToNextVideo 内部的 prevPlayVideo=this.playVideo 仍指向"已播放完的 video1"
				//   才能正确触发"切换前强制提交 video1 学时"
				for (let i = 0, len = this.videoTree.length; i < len; i++) {
					const chapterIndex = this.videoTree[i].children.findIndex(item => item.basePkId === next.parentPkId)
					if (chapterIndex > -1) {
						this.videoTree[i].children[chapterIndex].children[next.chapterIndex - 1] = next
						if (next.chapterIndex === 1) {
							this.playVideoChapter = this.videoTree[i]
							this.orderChapterLocal = this.videoTree[i]
						}
						break
					}
				}
				this.isNextVideoSwitch = true
				// 关键修复：切下一集时清掉 _lastEndedBasePkId，让下一集 ENDED 能被正确处理
				this._lastEndedBasePkId = null
				// 关键修复：清理 _playRecordMap 中已 ENDED 的视频记录
				//   下一集 CANPLAY 触发时需要再次新建学习记录（虽然 watchLength=0）
				//   后端 L255-258 短路逻辑保护：已有 videoEndTime 的不会再写
				if (this._playRecordMap && current && current.videoId) {
					delete this._playRecordMap[current.videoId]
				}
				this.switchToNextVideo(next)
			} else {
				// 已是最后一集
				console.log('[study1] 已是最后一集')
			}
		},
		/** 加载视频列表 **/
		loadVideoList() {
			this.$api.getVideoList({
				subject: this.$route.query.subject,
				studentId: this.userid,
				courseId: this.$route.query.courseid,
			}).then(res => {
				if (res.code === 0) {
					this.loadVideoListFormat(res.data)
				}
			})
		},
		clickToggleChapter(data) {
			this.playVideoChapter = data
		},
		/** 格式化视频列表 **/
		loadVideoListFormat(data) {
			this.videoTree = []
			// 关键修复：每次重新加载前重置 videoList，防止多次调用堆积
			this.videoList = []
			for (let i = 0, len = data.length; i < len; i++) {
				if (data[i].type === 3) {
					this.videoList.push(data[i])
				}
				if (data[i].parentPkId === 0) {
					this.videoTree.push(data[i])
				} else {
					this.videoTree = this.loadVideoListFormatRecursive(this.videoTree, data[i])
				}
			}
			// 关键修复：后端 getByParent 没有 ORDER BY，videoList 顺序不可靠
			//   按 chapterIndex 升序排序（chapterIndex 是同一 parentPkId 章节内的视频序号）
			//   跨章节保留原顺序，只在同章节内按 chapterIndex 排序
			this.videoList.sort((a, b) => {
				if (a.parentPkId === b.parentPkId) {
					return (a.chapterIndex || 0) - (b.chapterIndex || 0)
				}
				return 0
			})
			console.log('[study1] videoList 排序后:', this.videoList.map(v => ({ idx: v.chapterIndex, id: v.videoId })))
			if (JSON.stringify(this.playVideo) === '{}') {
				// 关键修复：找第一个 watchedFlag='0' 的视频（最早未观看）作为播放目标
				//   原本用 [length-1] 是错的——那会选最后一个视频
				const firstUnwatched = this.videoList.find(v => v.watchedFlag === '0')
				this.playVideo = firstUnwatched || this.videoList[0]
				if (firstUnwatched) {
					this.playVideoChapter = this.videoTree.find(c => c.basePkId === firstUnwatched.parentPkId)
					this.orderChapterLocal = this.playVideoChapter
				} else {
					this.playVideoChapter = this.videoTree[this.videoTree.length - 1]
				}
				this.loadVideo(this.playVideo)
			}
		},
		loadVideo(data) {
			// 销毁旧 Player 防止内存泄漏
			if (this.player) {
				console.log('[study1] destroy 旧 player, 当前 videoId=', this.playVideo && this.playVideo.videoId)
				try { this.player.destroy(true) } catch (e) { console.log('destroy old player fail', e) }
				this.player = null
			}
			// 重置 pendingSeekTime（防止上一个视频的恢复时间干扰下一个视频）
			this.pendingSeekTime = 0
			// 关键修复：不在主流程中调用 lastWatchLength（之前返回了 0 导致不跳转）
			// 改为在 Events.LOADED_METADATA 中调用（参数正确，返回真实的 watchLength）
			if (this.needSeekToLast) {
				// 签到进入/手动点击：先记录需要跳转，由 LOADED_METADATA 触发 lastWatchLength
				console.log('[study1] 加载视频，将通过 LOADED_METADATA 触发 lastWatchLength')
			} else {
				// 切下一集：不需要跳转，直接播放
				console.log('[study1] 切下一集，跳过 lastWatchLength')
			}
			this.createPlayerWithUrl(data)
		},
		/**
		 * 创建 player（已获取上次观看时间）
		 */
		createPlayerWithUrl(data) {
			console.log('[study1] createPlayerWithUrl 入口, videoId=', data && data.videoId, 'basePkId=', data && data.video && data.video.basePkId, 'oldPlayerAlive=', !!this.player, 'watchedFlag=', data && data.watchedFlag)
			// 已学过的视频允许拖动进度条（参考 study/CC 路径 banDrag=watchedFlag==1?'false':'true'）
			const isWatched = data && data.watchedFlag === '1'
			console.log('[study1] isWatched=', isWatched, '→ closeMoveSeek=', !isWatched, ' isCloseClickSeek=', !isWatched)
			getVideoUrl(data.video.basePkId,this.userid).then(res => {
			const isSupported = document.createElement('video').canPlayType('application/vnd.apple.mpegurl')
			if (isSupported) {
				// 原生支持 hls 播放
				this.player = new Player({
					el: document.querySelector('.player'),
					ignores: ['cssfullscreen', 'replay', 'pc', 'error'],//禁用播放器自带插件
					playsinline: true,
					fluid: true,
					poster:data.video.videoCover,
					muted: true,// 移动端自动播放策略要求静音
					// 关键修复：移除 autoplay: true，避免覆盖手动设置的 currentTime
					// 由 CANPLAY/SEEKED 事件手动调用 play()
					// autoplay: true,
					volume: 0.6,
					progress: {
						closeMoveSeek:false,//默认允许拖动，未学视频通过 Events.SEEKING 事件拦截强制 seek 回去
						isPauseMoving:true,//是否在拖拽的过程是否暂停视频播放
						isCloseClickSeek:false,//默认允许点击跳转，未学视频通过 Events.SEEKING 事件拦截强制 seek 回去
					},
					dynamicbg: {
						disable: true
					},
					mobile: {
						pressRate:1,//长按倍速
						gestureX:false,//禁用水平手势处理，水平手势快进/快退
					},
					fullscreen: {
						useCssFullscreen: true, // 使用网页内全屏替换全屏效果
						position: 'controlsRight' // 按钮移动到控制栏左侧
					},
					definition:{
					list:[{
						definition: '320p',// 清晰度
						url: res.videoItem[1].playurl,
						text: {
							zh: '标清', // 显示中文文案
							en: '320P' // 显示英文文案
						}
						},{
						definition: '480p',// 清晰度
						url: res.videoItem[0].playurl,  // 对应播放地址
						text: {
							zh: '高清',  // 显示中文文案
							en: '480P'   // 显示英文文案
						}
						}]
					},
					playbackRate: [1],//倍速
					'x5-video-player-type': 'h5',
					'x5-video-player-fullscreen': false,
					'x5-video-orientation': 'landscape'
				})
			} else if (HlsJsPlugin.isSupported()) { // 第一步
				console.log("调用插件",HlsJsPlugin.isSupported())
				this.player = new Player({
					el: document.querySelector('.player'),
					isLive: false,
					poster:data.video.videoCover,
					ignores: ['cssfullscreen', 'replay', 'pc', 'error'],//禁用播放器自带插件
					plugins: [HlsJsPlugin], // 第二步
					fluid: true,
					muted: true,// 移动端自动播放策略要求静音
					// 关键修复：移除 autoplay: true，避免覆盖手动设置的 currentTime
					// autoplay: true,
					volume: 0.6,
					progress: {
						closeMoveSeek:false,//默认允许拖动，未学视频通过 Events.SEEKING 事件拦截强制 seek 回去
						isPauseMoving:true,//是否在拖拽的过程是否暂停视频播放
						isCloseClickSeek:false,//默认允许点击跳转，未学视频通过 Events.SEEKING 事件拦截强制 seek 回去
					},
					dynamicbg: {
						disable: true
					},
					mobile: {
						pressRate:1,//长按倍速
						gestureX:false,//禁用水平手势处理，水平手势快进/快退
					},
					fullscreen: {
						useCssFullscreen: true, // 使用网页内全屏替换全屏效果
						position: 'controlsRight' // 按钮移动到控制栏左侧
					},
					definition:{
					list:[{
						definition: '320p',// 清晰度
						url: res.videoItem[1].playurl,
						text: {
							zh: '标清', // 显示中文文案
							en: '320P' // 显示英文文案
						}
						},{
						definition: '480p',// 清晰度
						url: res.videoItem[0].playurl,  // 对应播放地址
						text: {
							zh: '高清',  // 显示中文文案
							en: '480P'   // 显示英文文案
						}
						}]
					},
					playbackRate: [1],//倍速
					'x5-video-player-type': 'h5',
					'x5-video-player-fullscreen': false,
					'x5-video-orientation': 'landscape'
				})
			}
			// [study1] 调试日志
			this.player.on(Events.LOADED_METADATA, () => console.log('[study1] LOADED_METADATA', this.playVideo.videoId))
			this.player.on(Events.CANPLAY, () => console.log('[study1] CANPLAY', this.playVideo.videoId))
			this.player.on(Events.PLAY, () => console.log('[study1] PLAY'))
			this.player.on(Events.PLAYING, () => console.log('[study1] PLAYING'))
			this.player.on(Events.AUTOPLAY_PREVENTED, () => console.log('[study1] AUTOPLAY_PREVENTED'))

			// 关键修复：使用 LOADED_METADATA 触发 lastWatchLength（替代主流程）
			// 原因：主流程中调用返回 watchLength=0，但 LOADED_METADATA 中调用返回正确的 120
			// 这表明主流程的参数或时序有问题，LOADED_METADATA 中调用更可靠
			// 注意：切下一集时（needSeekToLast=false）不调用 lastWatchLength
			// 用 `on` 而不是 `once`（参考 study/CC 路径）：switchURL 路径下 player 实例不变，
			//   需要持久监听，否则切下一集时 LOADED_METADATA 触发但没人监听
			this.player.on(Events.LOADED_METADATA, () => {
				const videoId = this.playVideo && this.playVideo.videoId
				console.log('[study1] LOADED_METADATA 触发', videoId)
				if (!videoId || this.isNextVideoSwitch) return  // 切下一集：跳过
				if (this.pendingSeekTime > 0 && this.player && !this.middleFace) return  // 已 jump

				lastWatchLength({
					studentId: this.userid,
					videoId: videoId
				}).then(res => {
					const targetTime = res.watchLength || 0
					console.log('[study1] LOADED_METADATA 跳转时间', targetTime, 'videoId=', videoId)
					if (!this.player || this.middleFace) return

					if (targetTime > 0) {
						// 已观看过：跳到上次进度 + 自动播放（由 forceSeekTo 内部 play() 触发）
						this.player.currentTime = targetTime
						this.pendingSeekTime = targetTime
						this.forceSeekTo(targetTime)
					} else {
						// 关键修复：未观看过 → 只设 seek 0，让 CANPLAY/PLAYING 兜底自动播放
						// 思路（参考 study/CC 路径）：不在 LOADED_METADATA 中强行 play()，
						//   避免 audio element 未 ready 时被浏览器 reject。
						//   已有的 Events.PLAYING / Events.CANPLAY 兜底会在
						//   paused && !pendingSeekTime 时自动 play()。
						console.log('[study1] 首视频未观看，由 CANPLAY/PLAYING 兜底自动播放')
						this.player.currentTime = 0
					}
				}).catch(e => console.log('[study1] LOADED_METADATA 获取失败', e))
			})

			// PLAYING 作为兜底（首次观看 watchLength=0 时）
			// 注意：跳转场景的播放由 forceSeekTo 内部处理
			this.player.on(Events.PLAYING, () => {
				if (this.player && this.player.paused && !this.pendingSeekTime) {
					this.player.play().catch(() => {
						console.log('[study1] PLAYING 后 play 被拦截，等待用户手势')
						this.bindOnceUserGesture()
					})
				}
			})

			// CANPLAY 作为兜底（首次观看 watchLength=0 时）
			this.player.on(Events.CANPLAY, () => {
				if (!this.pendingSeekTime && this.player && this.player.paused) {
					// 首次观看且暂停时，尝试播放
					this.player.play().catch(() => {
						console.log('[study1] CANPLAY 自动播放失败，等待用户手势')
						this.bindOnceUserGesture()
					})
				}
				// 如果 pendingSeekTime > 0，由 forceSeekTo 处理

				// 关键修复（switchURL 路径兜底）：新建学习记录
				//   问题：xgplayer switchURL 切换视频后不一定重新触发 PLAY 事件
				//   用 _playRecordMap + CANPLAY 兜底补一次 recordStudyTime(0)
				//   注：CANPLAY 是 on 注册，会在 switchURL 后 video2 加载时触发
				const cur = this.playVideo
				if (!cur || !cur.videoId) return
				if (!this._playRecordMap) this._playRecordMap = {}
				if (!this._playRecordMap[cur.videoId]) {
					this._playRecordMap[cur.videoId] = true
					console.log('[study1] CANPLAY 兜底触发 recordStudyTime(0) 新建学习记录, videoId=', cur.videoId)
					this.recordStudyTime(0)
				}
			})

			// 关键修复：使用 PLAY（而非 PLAYING）作为播放状态触发
			// 原因：PLAY 在 play() 调用后立即触发，PLAYING 仅在实际播放时触发
			//
			// 关键修复 Bug A：去掉 PLAY 中的 recordStudyTime(0) 调用
			// 原因：ENDED 之后切下一集，xgplayer 在旧 player destroy 或新 player 创建瞬间
			//   会再次 fire 残留 PLAY 事件，导致同一视频被 recordStudyTime 调用两次（一次 type='next'，一次 type=''）
			//   引发 watchVideo API 重复发送
			// 节流 60秒记录仍保留（定时器会在每分钟首帧时记录当前进度）
			this.player.on(Events.PLAY,()=>{
				if (this.middleFace === true) {
					this.timingSubmitStudy();
					return
				}
				this.isPlayState = true
				// 关键修复（参考 study/CC 路径）：视频开始播放时调 recordStudyTime(0)
				//   作用：第一次播放该 chapterId 时会在后端新建学习记录（videoStartTime=now）
				//   视频播放结束时再调一次 recordStudyTime(duration) 更新 videoEndTime/studyDuration/gainPeriod
				//   → 形成完整的学习记录闭环
				//
				// 关键修复 Bug A：必须避免重复调用
				//   现象：xgplayer 在视频源切换后（switchURL）会再次 fire 残留 PLAY 事件
				//   解决：用 _playRecordMap 记录已调用过 recordStudyTime(0) 的 videoId，避免重复
				const playingVideo = this.playVideo
				if (playingVideo && playingVideo.videoId && !this._playRecordMap) {
					this._playRecordMap = {}
				}
				if (playingVideo && playingVideo.videoId && this._playRecordMap && !this._playRecordMap[playingVideo.videoId]) {
					this._playRecordMap[playingVideo.videoId] = true
					console.log('[study1] PLAY 触发 recordStudyTime(0) 新建学习记录, videoId=', playingVideo.videoId)
					this.recordStudyTime(0)
				}
				// 开启节流 60S 一次
				this.timingSubmitStudyThrittle(60000)
			})

			this.player.on(Events.PAUSE,()=>{
				this.timingSubmitStudyThrittle('clear')
				this.isPlayState = false
			})

			// PLAYING 仅做实际播放状态的标记和索引同步
			this.player.on(Events.PLAYING, () => {
				this.orderVideoLocalIndex = this.videoList.indexOf(this.orderVideoLocal);
			})

			// 关键修复：未学视频禁止拖动进度条
			//   progress 配置 closeMoveSeek/isCloseClickSeek 在某些场景下不生效
			//   通过 Events.SEEKING 事件拦截：未学视频被拖动时强制 seek 回原位置
			//   用 _seekLock 标志防止"设 currentTime 又触发 SEEKING"的递归死循环
			this.player.on(Events.SEEKING, () => {
				const playingVideo = this.playVideo
				if (!playingVideo) return
				if (playingVideo.watchedFlag === '1') return  // 已学视频允许拖动
				// 未学视频：拦截拖动，恢复到拖动前的位置
				if (this._seekLock) return  // 防止递归
				this._seekLock = true
				if (this.player && this._lastAllowedCurrentTime !== undefined) {
					console.log('[study1] SEEKING 拦截，未学视频拖动被阻止，恢复 currentTime=', this._lastAllowedCurrentTime)
					try {
						this.player.currentTime = this._lastAllowedCurrentTime
					} catch (e) { console.log('[study1] SEEKING 恢复失败', e) }
				}
				// 下一帧清掉锁（避免一直锁住导致用户后续无法操作）
				setTimeout(() => { this._seekLock = false }, 100)
			})
			this.player.on(Events.TIME_UPDATE, () => {
				// 记录最近一次正常播放的 currentTime，作为未学视频拖动后恢复的目标
				if (this.player) this._lastAllowedCurrentTime = this.player.currentTime
			})

			// 关键修复：监听自动播放被拦截事件（移动端常见）
			this.player.on(Events.AUTOPLAY_PREVENTED, () => {
				console.log('[study1] 自动播放被浏览器拦截，等待用户手势')
				this.bindOnceUserGesture()
			})

			this.player.on(Events.ENDED, () => {
				const endedVideo = this.playVideo
				const curTime = this.player ? (this.player.currentTime || 0) : 0
				const duration = endedVideo && endedVideo.video ? endedVideo.video.videoDuration : 0
				console.log('[study1] ENDED 入口 触发, this.playVideo=', endedVideo && endedVideo.videoId, 'basePkId=', endedVideo && endedVideo.basePkId, '_lastEndedBasePkId=', this._lastEndedBasePkId, 'curTime=', curTime, 'duration=', duration)
				// 关键修复：检测"假 ENDED"（switchURL 后残留 ended 状态）
				//   现象：video1 真正 ENDED 后 switchURL 切到 video2，但 xgplayer 的 video element ended 状态未重置
				//   video2 刚加载就立即触发 ENDED 事件，但 curTime 远小于 duration
				//   → 之前的代码会误认为 video2 ENDED → loadNextVideo → 跳到 video3
				// 解决：如果 curTime < duration - 2（容差 2s），说明视频没真播完，跳过此次 ENDED
				if (duration > 0 && curTime < duration - 2) {
					console.log('[study1] ENDED 假事件，跳过（curTime=', curTime, '< duration - 2 =', duration - 2, '）')
					return
				}
				console.log('[study1] ENDED 触发，videoId=', endedVideo.videoId, 'basePkId=', endedVideo.basePkId, 'lastEnded=', this._lastEndedBasePkId)
				// 关键修复：幂等保护 - 同一 basePkId 不重复处理
				//   原因：xgplayer 在 switchURL 切换视频源后，可能触发残留的 ended 事件
				//   此时 this.playVideo 已经是 video2，handler 会误将 video2 当作 video1 处理
				//   → recordStudyTime → watchVideo → loadNextVideo → 跳到 video3（跳过 video2）
				if (this._lastEndedBasePkId === endedVideo.basePkId) {
					console.log('[study1] ENDED 重复触发，跳过 basePkId=', endedVideo.basePkId)
					return
				}
				this._lastEndedBasePkId = endedVideo.basePkId
				this.isPlayState = false
				this.timingSubmitStudyThrittle('clear')
				// 传 endedVideo 而非 this.playVideo（避免响应式引用串扰）
				this.recordStudyTime(endedVideo.video.videoDuration, 'next', endedVideo)
				if (localStorage.getItem('videoPlayNums')) {
					let times = parseInt(localStorage.getItem('videoPlayNums')) + 1;
					localStorage.setItem('videoPlayNums', '' + times + '');
				}
			})
			})
		},
		/**
		 * 切换到下一个视频（不销毁 player）
		 * 关键修复：使用 switchURL 保留 user gesture context，确保自动播放
		 * 同时显式调用 lastWatchLength 获取新视频的上次观看时间
		 */
		switchToNextVideo(video) {
			console.log('[study1] switchToNextVideo 入口, videoId=', video && video.videoId, 'oldPlayerAlive=', !!this.player)
			if (!this.player) {
				// 没有 player 时需要走完整 loadVideo 流程
				this.needSeekToLast = true
				this.loadVideo(video)
				return
			}
			// 注意：switchURL 路径不销毁 player，原有的 Events.* 监听仍然生效
			// 但 ENDED/PLAYING/CANPLAY 是用 once 注册的，第一次触发就移除
			// 而 PLAY/PAUSE/ENDED（持久）是 on 注册，多次触发不会重复注册
			// 这里保留入口日志用于后续日志诊断
			// 关键修复：在改 playVideo 之前先记录当前视频引用（用于提交学时）
			const prevPlayVideo = this.playVideo
			// 关键修复：切换前先强制提交一次当前视频的学时（用 prevPlayVideo 避免读错）
			//   原因：timingSubmitStudyThrittle('clear') 会取消正在排队的 viewLogPush，
			//   导致 video1 在切换瞬间未提交的"过程学时"丢失
			//   必须用 prevPlayVideo（=video1）调用 timingSubmitStudy，否则 this.playVideo 已被改成 video2
			//   → viewLogPush 会用 video2.videoId 但 video2.currentTime=0，记不到 video1 的进度
			if (this.player && prevPlayVideo && prevPlayVideo.video && prevPlayVideo.video.videoDuration && prevPlayVideo.basePkId !== video.basePkId) {
				console.log('[study1] 切换视频前强制提交 video1 学时, videoId=', prevPlayVideo.videoId, 'basePkId=', prevPlayVideo.basePkId, 'currentTime=', this.player.currentTime)
				viewLogPush({
					chapterId: prevPlayVideo.basePkId,
					courseId: this.$route.query.courseId,
					planId: this.$store.state.user.planid,
					signId: this.$route.query.signId,
					studentId: this.userid,
					videoId: prevPlayVideo.videoId,
					videoLength: prevPlayVideo.video.videoDuration,
					// 关键修复：watchLength 取整（与 recordStudyTime 一致）
					watchLength: Math.floor(this.player.currentTime || 0)
				}).then(res => {
					console.log('[study1] 切换前强制提交 viewLogPush 返回', JSON.stringify(res))
				}).catch(e => console.log('[study1] 切换前强制提交 viewLogPush 失败', e))
			}
			// 更新 playVideo 引用（事件回调中需要）
			this.playVideo = video
			// 重置 pendingSeekTime（新视频的时间）
			this.pendingSeekTime = 0
			// 重置学时相关状态
			this.timingSubmitStudyThrittle('clear')

			getVideoUrl(video.video.basePkId, this.userid).then(res => {
				const url = res.videoItem[0].playurl
				console.log('[study1] switchToNextVideo getVideoUrl 返回, 目标 videoId=', video.videoId, 'basePkId=', video.basePkId, 'url=', url && url.substring(0, 80))
				// 使用 switchURL 保留 player 实例（关键：保留 user gesture context）
				if (typeof this.player.switchURL === 'function') {
					// 关键修复：清掉上一视频的 _lastAllowedCurrentTime
					//   原因：switchURL 后新视频 src 替换会触发 SEEKING（浏览器内部 seek 到 0）
					//   SEEKING 拦截器用 _lastAllowedCurrentTime 恢复，如果不清，会恢复成 video1 的结束时间（如 1:56=116s）
					this._lastAllowedCurrentTime = 0
					this.player.switchURL(url).then(() => {
						console.log('[study1] switchURL 完成，下一集从 0 开始播放, videoId=', video.videoId)
						// 关键修复：xgplayer.switchURL 不会自动重置 video element 的 currentTime
						//   切换前 video1 END 时 currentTime ≈ video1.duration（用户拖到的 1:56 = 116s）
						//   switchURL 后新视频 src 替换了，但 currentTime 仍是 116
						//   必须显式重置为 0，否则未学视频从 1:56 开始播放
						try {
							this.player.currentTime = 0
							console.log('[study1] switchURL 后重置 currentTime=0')
						} catch (e) { console.log('[study1] switchURL 重置 currentTime 失败', e) }
						this.player.play().catch(() => {
							console.log('[study1] switchURL 后 play 被拦截，等待用户手势')
							this.bindOnceUserGesture()
						})
					}).catch(err => {
						console.log('[study1] switchURL 失败，降级为重建', err)
						// 降级时也需要设置 needSeekToLast = false（切下一集不跳转）
						this.needSeekToLast = false
						this.loadVideo(video)
					}).finally(() => {
						// 关键修复：异步流程结束（含成功/失败/异常）后清理 isNextVideoSwitch，
						// 让后续手动点击切换视频时仍能正常走 lastWatchLength 流程
						this.isNextVideoSwitch = false
					})
				} else {
					// switchURL 不存在，降级为 loadVideo（销毁重建）
					console.log('[study1] switchURL API 不存在，使用 loadVideo')
					// 降级时也需要设置 needSeekToLast = false
					this.needSeekToLast = false
					this.loadVideo(video)
					// 关键修复：降级路径也清理 isNextVideoSwitch
					this.isNextVideoSwitch = false
				}
			}).catch(err => {
				console.log('[study1] 获取视频URL失败', err)
				// 关键修复：异常路径也要清理 isNextVideoSwitch，避免状态污染
				this.isNextVideoSwitch = false
			})
		},
		/** 记录学时 **/
		recordStudyTime(watchLength, type = '', video) {
			// 关键修复：用传入的 video 参数（来自 ENDED 闭包），避免响应式引用串扰
			//   当 type='next' 时（即 ENDED 触发），video 是 ENDED 时实际正在播放的视频
			//   而非 this.playVideo（可能已被 switchToNextVideo 改写）
			const cur = video || this.playVideo
			const ref = this.orderVideoLocal
			// 关键修复：用传入的 watchLength 参数，不用 this.player.currentTime
			//   原因：this.player.currentTime 是响应式引用，可能在异步期间被 switchToNextVideo 改写
			//   参数 watchLength 是 END 时同步捕获的 video1.duration，最可靠
			//
			// 关键修复：把 watchLength 强制转为整数（参考 study/CC 路径）
			//   原因：video.videoDuration 是后端 String 类型，传到前端是 String（如 "120"）
			//   原代码 typeof watchLength === 'number' 检查会失败，回退到 player.currentTime（浮点 120.116825）
			//   后端 ProcWatchHistoryReq.watchLength 是 Integer，浮点会被 fastjson 截断（120.116825 → 120）
			//   但这种隐式转换不可靠，且与 study(CC版) 行为不一致（CC版直接传 String "120"）
			//   → 改为：先把 watchLength 转为数字（parseInt 或 parseFloat），再 Math.floor 取整
			let safeWatchLength
			if (typeof watchLength === 'number') {
				safeWatchLength = Math.floor(watchLength)
			} else if (typeof watchLength === 'string') {
				safeWatchLength = parseInt(watchLength) || 0
			} else {
				safeWatchLength = this.player ? Math.floor(this.player.currentTime || 0) : 0
			}
			console.log('[study1] recordStudyTime watchLength=', safeWatchLength, '(原始=', watchLength, '类型=', typeof watchLength, ')', 'cur=', cur.videoId, 'cur.basePkId=', cur.basePkId, 'ref=', ref && ref.basePkId, 'type=', type, 'isNextVideoSwitch=', this.isNextVideoSwitch)

			// 关键修复：用 cur（实际触发 ENDED 的视频）做幂等判断，避免异步串扰
			//   1) 已切下一集（isNextVideoSwitch=true）：video1 残留 ENDED 触发，不应再调 loadNextVideo
			//   2) cur.basePkId === ref.basePkId：正常 ENDED，调 watchVideo + loadNextVideo
			//   3) cur.basePkId !== ref.basePkId 且 isNextVideoSwitch=false：用户手动点已学视频复习 ENDED，
			//      也应该调 watchVideo + loadNextVideo（顺序上的下一个），不再跳过
			if (this.isNextVideoSwitch && watchLength > 0) {
				// 关键修复：只在 ENDED 触发的"切下一集"流程中跳过
				//   CANPLAY 触发的 recordStudyTime(0)（新建学习记录）不应被跳过
				//   否则 switchURL 后 video2 加载时不会建记录
				console.log('[study1] 已在切下一集流程中，跳过 recordStudyTime (watchLength=', safeWatchLength, ')')
				return
			}
			if (cur && (!ref || cur.basePkId === ref.basePkId)) {
				console.log('[study1] recordStudyTime 调 watchVideo, videoId=', cur.videoId, 'basePkId=', cur.basePkId, 'watchLength=', safeWatchLength, 'videoLength=', cur.video.videoDuration)
				// 关键修复：完全对齐 study/CC 版的 watchVideo 请求结构
				//   study (CC) recordStudyTime 直接传 video.videoDuration（String "120"）作为 watchLength
				//   study1 修改后改为 Integer 120（parseInt）
				//   后端 ProcWatchHistoryReq.watchLength 是 Integer，两种都能解析，但 String 更接近 CC 版行为
				//
				// 关键修复：不传 planId（与 study/CC 版当前代码一致）
				const watchVideoPayload = {
					studentId: this.userid,
					signId: this.$route.query.signId,
					videoId: cur.videoId,
					chapterId: cur.basePkId,
					courseId: this.$route.query.courseid,
					watchLength: safeWatchLength,
					videoLength: cur.video.videoDuration
				}
				console.log('[study1] watchVideo 请求体=', JSON.stringify(watchVideoPayload), 'studentId类型=', typeof this.userid, 'signId类型=', typeof this.$route.query.signId, 'videoId类型=', typeof cur.videoId, 'chapterId类型=', typeof cur.basePkId, 'watchLength类型=', typeof safeWatchLength, 'videoLength类型=', typeof cur.video.videoDuration)
				this.$api.watchVideo(watchVideoPayload).then(res => {
					console.log('[study1] watchVideo API 返回', JSON.stringify(res))
					if (res.code === 0) {
						// 关键修复：传 cur（实际 ENDED 的视频）作为 endedVideo
						//   让 loadNextVideo 基于实际播放的视频找下一个，避免用 orderVideoLocal 导致跳过
						if (type === 'next') this.loadNextVideo(cur)
					}
				}).catch((err) => {
					console.log('[study1] watchVideo API 失败', err)
					if (type === 'next') this.loadNextVideo(cur)
				})
			} else {
				// 关键修复：cur.basePkId !== ref.basePkId 且不在切下一集流程中
				//   场景：用户手动 clickVideo 进入已学视频（watchedFlag='1'）复习
				//   ref 是上一次的 orderVideoLocal（可能未更新），cur 是当前播放的视频
				//   此时仍需调 watchVideo 保存学时，并调 loadNextVideo 切到下一集
				console.log('[study1] cur 与 orderVideoLocal 不一致（用户复习模式），仍尝试切下一集')
				this.$api.watchVideo({
					studentId: this.userid,
					signId: this.$route.query.signId,
					videoId: cur.videoId,
					chapterId: cur.basePkId,
					courseId: this.$route.query.courseid,
					watchLength: safeWatchLength,
					videoLength: cur.video.videoDuration
				}).then(() => {
					if (type === 'next') this.loadNextVideo(cur)
				}).catch(() => {
					if (type === 'next') this.loadNextVideo(cur)
				})
			}
		},
		delayEndTheStudyProc() {
			this.timer = setTimeout(() => {
				this.signBackNoPhoto();
			}, 180000);
		},
		destroyedTimer() {
			if (this.timer !== null) {
				clearTimeout(this.timer);
			}
		},
		/**
		 * @param { number | string } wait： 执行时间 (number) 是否停止定时器 (string: clear)
		 */
		timingSubmitStudyThrittle(wait) {
			const _this = this;
			if (typeof wait === 'string' && wait === 'clear') {
				if (this.submitStudyTimer) {
					clearTimeout(_this.submitStudyTimer)
					this.submitStudyTimer = null
				}
			} else if (typeof wait === 'number') {
				if (!this.submitStudyTimer) {
					this.submitStudyTimer = setTimeout(() => {
						_this.timingSubmitStudy();
						_this.submitStudyTimer = null
						_this.timingSubmitStudyThrittle(wait)
					}, wait)
				}
			}
		},
		// 提交学时，20S一次，暂停时、播放结束时，均需保存学时
		timingSubmitStudy(/*...data */) {
			const _this = this;
			viewLogPush({
				chapterId: this.playVideo.basePkId /* '章节ID' */,
				courseId: this.$route.query.courseId /*'课程ID'*/,
				planId: this.$store.state.user.planid /* '学员计划ID'*/,
				signId: this.$route.query.signId /* '签到ID'*/,
				studentId: this.userid /* '学员ID'*/,
				videoId: this.playVideo.videoId /* '视频ID' */,
				videoLength: this.playVideo.video.videoDuration /* '视频总长度' */,
				// 关键修复：watchLength 改为整数（参考 study/CC 路径）
				//   原因：player.currentTime 是浮点，后端 Integer 接收需要取整
				watchLength: Math.floor(this.player.currentTime || 0) /* '当前观看长度' */
			}).then(res => {
				if (res.signTime) {
					this.player.pause();
					this.player.exitCssFullscreen();
					_this.middleFace = true;
					this.$utils.dialog.alert('需要进行人脸识别，请端正手机拍照！（不要躺着，手机拿正拍照）', () => {
						// 此处 调用APP 摄像头方法
						if (_this.isUseJSPlayPhoto) {
							_this.handleFace()
						} else {
							_this.$refs.imgChange.click()
						}
					});
					/* 江西初学3分钟内 */
					if ( _this.$store.state.user.planid == 151 ) _this.delayEndTheStudyProc();
				}
			}).catch(() => {
				_this.player.pause();
				clearTimeout(_this.submitStudyTimer)
			})
		},
		/** 拍照区域 **/
		handleFace() {
			const _this = this
			if (this.faceRecognitionType === null) {
				_this.$utils.dialog.alert('手速太快休息一会儿~');
				return;
			}
			if (this.faceRecognitionType === '0') {
				this.signBackNoPhoto();
			}
			if (this.loadingFace) return
			// 关键修复：拍照前先暂停视频，避免人脸识别期间视频继续播放
			if (this.player && !this.middleFace) {
				try { this.player.pause(); } catch (e) { console.log('[study1] pause fail', e) }
			}
			if (this.$store.state.cache.screen.wx) {
				wx.chooseImage({
					count: 1, // 默认9
					sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
					sourceType: ['camera'], // 可以指定来源是相册还是相机，默认二者都有
					success: function (res) {
						wx.uploadImage({
							localId: res.localIds[0], // 需要上传的图片的本地ID，由chooseImage接口由 chooseImage 接口获得
							isShowProgressTips: 1, // 默认为1，显示进度提示
							success: function (uploadRes) {
								_this.loadingFace = true
								_this.$api.wxCompareFace({
									mediaId: uploadRes.serverId,
									signId: _this.$route.query.signId,
									chapterId: _this.playVideo.basePkId
								}).then((res) => {
									_this.loadingFace = false
									if (res.code === 0) {
										if (_this.middleFace) { // 如果是中间验证人脸，验证完成之后，还原为false，如果是false，就走签退
											_this.handleFaceSuccess()
										} else {
											_this.signBack({
												mediaId: uploadRes.serverId
											})
										}
									} else {
										// 人脸识别失败，需要用户主动触发再次识别
										_this.handleFaceFail()
									}
								}).catch(() => {
									_this.loadingFace = false
									_this.handleFaceFail()
								})
							}
						})
					}
				})
			} else {
				if (this.$store.state.cache.screen.isAndroid) {
					if (uni) {
						uni.postMessage({
							data: {
								action: 'setCamera'
							}
						});
						//return;
					}
					if (window.Android_JS && window.Android_JS.androidPhoto) {
						window.Android_JS.androidPhoto();
					}
				}
				if (this.$store.state.cache.screen.isIos) {
					if (uni) {
						uni.postMessage({
							data: {
								action: 'setCamera'
							}
						});
						//return;
					}
					if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosPhoto) {
						window.webkit.messageHandlers.iosPhoto.postMessage(null);
					}
				}
			}
		},
		/**
		 * 人脸识别通过后的统一处理
		 * 关键修复：使用 Events.PLAY 事件确保 UI 同步，并保留 pendingSeekTime 作为 fallback
		 */
		handleFaceSuccess() {
			const _this = this
			_this.middleFace = false
			const pos = _this.player ? (_this.player.currentTime || 0) : 0
			const targetTime = Math.max(0, pos - 2)
			_this.pendingSeekTime = targetTime
			_this.$utils.dialog.alert('验证成功，请继续学习', () => {
				if (!_this.player) return
				// 关键修复：直接设置 currentTime 并调用 play，不再等待 play 结果
				// 即使 play() reject，currentTime 也已设置，下次用户点击播放器会继续播放
				try {
					_this.player.currentTime = targetTime
					_this.player.play().then(() => {
						_this.pendingSeekTime = 0
					}).catch(() => {
						console.log('[study1] 人脸后 play 被拦截，等待用户手势')
						_this.bindOnceUserGesture()
					})
				} catch (e) {
					console.log('[study1] play 调用异常', e)
					_this.bindOnceUserGesture()
				}
			})
		},
		/**
		 * 人脸识别失败后处理
		 * 关键修复：提示用户再次进行人脸识别，不自动恢复播放
		 */
		handleFaceFail() {
			const _this = this
			_this.$utils.dialog.alert('人脸识别未通过，请重新进行人脸识别', () => {
				// 重新触发拍照流程
				if (_this.isUseJSPlayPhoto) {
					_this.handleFace()
				} else {
					_this.$refs.imgChange.click()
				}
			})
		},
		imgChange(event) {
			if (this.loadingFace) return
			let file = event.target.files[0];
			const _this = this;
			if (this.player) {
				this.player.pause();
			}
			new Compressor(file, {
				quality: 0.9,
				maxWidth: 413,
				maxHeight: 626,
				convertTypes: ['image/jpeg'],
				convertSize: 1000000,
				success(result) {
					console.log('study照片压缩成功');
					let reader = new FileReader();
					reader.readAsDataURL(result);
					reader.onload = (event) => {
						console.log('study执行receivePhotoResult');
						_this.receivePhotoResult(event.target.result)
					}
				},
				error(err) {
					console.log(err);
					_this.$utils.dialog.alert('照片压缩时出错，请重拍');
				}
			});
		},
		loadVideoListFormatRecursive(list, item) {
			for (let i = 0, len = list.length; i < len; i++) {
				if (list[i].basePkId === item.parentPkId) {
					if (!list[i].children) list[i].children = []
					list[i].children.push(item)
					if (JSON.stringify(this.orderVideoLocal) === '{}') {
						if (item.watchedFlag === '0') {
							this.orderVideoLocal = item
							this.playVideo = item
							this.playVideoChapter = this.videoTree.find(item => item.basePkId === list[i].parentPkId)
							this.orderChapterLocal = this.videoTree.find(item => item.basePkId === list[i].parentPkId)
							this.loadVideo(item)
						}
					}
					break
				} else if (list[i].children) {
					list[i].children = this.loadVideoListFormatRecursive(list[i].children, item)
				}
			}
			return list
		},
		// 点击回退
		clickNavBack() {
			const _this = this
			this.$api.checkSignOut(this.$route.query.signId).then(res => {
				if (res.code === 0) {
					if (res.data.canBeSignOut == 1) {
						Dialog.confirm({
							title: '温馨提示',
							message: '如您退出学习，请先点击签退按钮签退，否则会影响学时送审。',
							theme: 'round-button',
							confirmButtonColor: store.state.app.theme.colorMain,
							cancelButtonColor: '#D4D4D4',
							confirmButtonText: '签退',
							width: 290,
						}).then((res) => {
							if (res === 'confirm') {
								if (_this.isUseJSPlayPhoto) {
									_this.handleFace()
								} else {
									_this.$refs.imgChange.click()
								}
							}
						}).catch((err) => {
							if (err === 'cancel') {
								// _this.$router.push('/train')
							}
						})
					} else {
						_this.$router.push('/train')
					}
				}
			})
		},
		receivePhotoResult(base64) {
			const _this = this;
			this.loadingFace = true
			if (',102,104,105,106,168,'.indexOf(',' + _this.categoryId + ',') !== -1 && _this.provinceCode === '360000') {
				// 江西初学
				if (_this.middleFace) { // 如果是中间验证人脸，验证完成之后，还原为false，如果是false，就走签退
					this.destroyedTimer();
					this.$api.compareFace({
						signId: _this.$route.query.signId,
						photo: base64,
						chapterId: _this.playVideo.basePkId
					}).then((res) => {
						if (res.code === 0) {
							_this.handleFaceSuccess()
						} else {
							_this.handleFaceFail()
						}
						_this.loadingFace = false
					}).catch(() => {
						_this.loadingFace = false
						_this.handleFaceFail()
					})
				} else {
					_this.signBack({base64})
				}
			} else {
				this.$api.compareFace({
					signId: _this.$route.query.signId,
					photo: base64,
					chapterId: _this.playVideo.basePkId
				}).then((res) => {
					if (res.code === 0) {
						if (_this.middleFace) { // 如果是中间验证人脸，验证完成之后，还原为false，如果是false，就走签退
							_this.handleFaceSuccess()
						} else {
							_this.signBack({base64})
						}
					} else {
						// 人脸识别失败
						_this.handleFaceFail()
					}
					_this.loadingFace = false
				}).catch(() => {
					_this.loadingFace = false
					_this.handleFaceFail()
				})
			}
		},
		/** 签退 **/
		signBack({base64 = '', mediaId = ''}) {
			const _this = this
			this.$api.signOut(this.$route.query.signId, base64, mediaId).then((res) => {
				if (res.code === 0) {
					_this.$utils.dialog.alert('签退成功', () => {
						_this.$router.replace('/train')
					})
				}
			})
		},
		/** 签退不带照片 **/
		signBackNoPhoto() {
			const _this = this
			Dialog.confirm({
				title: '温馨提示',
				theme: 'round-button',
				message: '是否确认签退',
				cancelButtonColor: this.$store.state.app.theme.colorMain,
				confirmButtonColor: '#ee0a24',
				cancelButtonText:'确认',
				confirmButtonText:'取消',
			}).then(() => {
			}).catch(() => {
				this.$api.signOutNoPhoto(this.$route.query.signId).then((res) => {
					if (res.code === 0) {
						_this.$utils.dialog.alert('签退成功', () => {
							window.location.href = sessionStorage.getItem("loginSteam")
							window.location.reload()
						})
					}
				})
			});
		},
		signtip(index) {
			this.iscolor = index;
			if (index === 0) {
				this.showPopover = false;
			} else {
				this.showPopover = false;
				localStorage.setItem('showPopover', JSON.stringify(this.showPopover));
			}
		},
		/**
		 * 强制跳转到指定时间（循环重试直到 currentTime 稳定）
		 * 关键修复：使用最原始的 seek 方法
		 * 原因：移动端某些浏览器在 LOADED_METADATA 触发时 video.currentTime 设置可能不生效，
		 *      通过循环重试 + setTimeout 直到 currentTime 稳定在目标时间附近
		 * 关键修复：currentTime 稳定后立即调用 play()，不依赖 PLAYING 事件
		 *
		 * 关键修复：targetTime=0 时也执行（首视频未观看情况）
		 *   原逻辑 `if (!targetTime) return` 会跳过 targetTime=0，导致首视频无法自动播放
		 */
		forceSeekTo(targetTime) {
			if (!this.player || !targetTime) return
			// 注：targetTime=0 场景由 LOADED_METADATA 分支直接用"player.src + play()"处理，
			//   这里不再处理（避免重复 play）
			let retryCount = 0
			const maxRetries = 30
			const tolerance = 1  // 容差 1 秒
			let seekDone = false
			const trySeek = () => {
				if (!this.player) return
				const cur = this.player.currentTime || 0
				if (Math.abs(cur - targetTime) < tolerance) {
					// currentTime 已经在目标范围内，停止重试
					console.log('[study1] forceSeekTo 完成', cur, '准备播放')
					// 关键修复：currentTime 稳定后立即调用 play()
					if (!seekDone) {
						seekDone = true
						this.player.play().catch(() => {
							console.log('[study1] forceSeekTo 后 play 被拦截，等待用户手势')
							this.bindOnceUserGesture()
						})
					}
					return
				}
				if (retryCount >= maxRetries) {
					console.log('[study1] forceSeekTo 达到最大重试次数', cur)
					return
				}
				try {
					this.player.currentTime = targetTime
					console.log('[study1] forceSeekTo 重试', retryCount, '->', this.player.currentTime)
				} catch (e) {
					console.log('[study1] forceSeekTo 异常', e)
				}
				retryCount++
				setTimeout(trySeek, 200)
			}
			trySeek()
		},
		/**
		 * 监听一次性首点击/触摸，用于自动播放失败时由用户手势恢复播放
		 * 移动端浏览器自动播放策略要求：必须先有用户手势才能解除静音并播放
		 * 关键修复（移动端）：
		 *  1. touchstart 优先（移动端手势），click 作为兜底
		 *  2. 过滤来自播放器控件的事件，避免循环触发
		 *  3. play reject 时手动 emit Events.PLAY 触发 UI 同步，避免按钮消失
		 */
		bindOnceUserGesture() {
			if (this._gestureBound) return
			this._gestureBound = true
			const handler = (e) => {
				// 移动端：忽略来自播放器控件的手势（避免循环触发或重复触发）
				if (e && e.target && e.target.closest && (e.target.closest('.xgplayer') || e.target.closest('[class*="xg-"]'))) {
					return
				}
				document.removeEventListener('click', handler)
				document.removeEventListener('touchstart', handler)
				this._gestureBound = false
				if (!this.player) return
				// 用户手势后解除静音（自动播放必须是静音的）
				this.player.muted = false
				this.player.play().then(() => {
					if (this.pendingSeekTime > 0) {
						this.player.currentTime = this.pendingSeekTime
						this.pendingSeekTime = 0
					}
				}).catch((err) => {
					console.log('[study1] 用户手势后 play 仍失败', err)
					// 关键修复：手动触发 PLAY 事件，确保 xgplayer UI 同步（按钮显示）
					try {
						this.player.emit(Events.PLAY)
					} catch (e) {
						console.log('[study1] emit PLAY 异常', e)
					}
				})
			}
			// 移动端：touchstart 优先（手势更早触发），click 作为兜底
			document.addEventListener('touchstart', handler, { once: true, passive: true })
			document.addEventListener('click', handler, { once: true })
		},
	},
};
</script>
<style scoped>
.sign-wrap {
	position: absolute;
	top: 31px;
	right: 44px;
	width: 60%;
	z-index: 9999;
	/* position: relative; */
}

.sign-wrap img {
	width: 100%;
}

.sign-wrap .sign-text {
	width: 100%;
	display: flex;
	margin: -30px 0 0 0;
	font-size: 12px;
}

.sign-wrap .sign-text .text-box {
	display: flex;
	margin-left: 6px;
}

.sign-wrap .sign-text .text-box .text-btns {
	width: 10px;
	height: 10px;
	background-color: #fff;
	border-radius: 5px;
	margin: 4px 4px 0 0;
}

.sign-wrap .sign-text .text-box .btn-color {
	background-color: #ffac1b;
}

.sign-wrap .sign-text .text-text {
	border-bottom: 1px solid #000;
}
</style>
